import React from 'react'
import classNames from 'classnames'
import styles from './LayoutStack.module.css'
import { CommonLayoutStackProps, LayoutStackProps } from './types'

function LayoutStack({
  as: Tag = 'div',
  className,
  style,
  space = '200',
  container,
  flex,
  ...props
}: LayoutStackProps) {
  return (
    <Tag
      {...(props as Extract<typeof props, CommonLayoutStackProps>)}
      className={classNames(styles.stack, { [styles.container!]: container, [styles.flex!]: flex }, className)}
      style={
        {
          ...style,
          '--space': `var(--betterplace-spacing-${space})`,
        } as React.CSSProperties
      }
    >
      {props.children}
    </Tag>
  )
}

export default LayoutStack
